import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from "@angular/core";
//import { ClientDataService } from "Services/client-data.service";
//import { MapService } from "Services/map.service";
//import { AuthenticationService } from "Services/authentication.service";
import { EventService } from "Services/event.service";
import { FetchDataService } from "Services/fetch-data.service";
import { AuthenticationService } from "Services/authentication.service";
//import { AdalService } from "ng2-adal/dist/core";
import { Adal4Service as AdalService } from 'adal-angular4';
import { AppConfig } from "Classes/AppConfig";
import { User } from "Classes/User";
import { ModalConfig } from "Classes/ModalConfig";
import { JwtHelper } from "Classes/jwtHelper";


declare var $: any;

@Component({
    //moduleId: module.id,
    selector: "login",
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})
export class LoginComponent implements OnInit, AfterViewInit {
    constructor(
        //private mapService: MapService,
        //private clientDataService: ClientDataService,
        private eventService: EventService,
        private authenticationService: AuthenticationService,
        private fetchDataService: FetchDataService,
        private appConfig: AppConfig,
        private adalService: AdalService
    ) { }
    @Input() login: boolean;
    @Input() errorMessage: string;
    @Output() loginChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() errorMessageChange: EventEmitter<string> = new EventEmitter<string>();

    listeners: any = [];

    hostnameArray: string[] = window.location.hostname.split('.');

    //Hostname
    hostName: string = this.hostnameArray[this.hostnameArray.length - 2];

    loginPrompt: string = "Login:";
    ssoButtonText: string = process.env.ENV == "idevelopment" || process.env.ENV == "iproduction" ? "Login" : "Use " + this.hostnameArray[this.hostnameArray.length - 2] + " Credentials";
    isInternational = process.env.ENV == "idevelopment" || process.env.ENV == "iproduction";
    loadingText: string = "";
    obj: any;
    title: string = "Login";
    email: any;
    password: any;
    token: any;
    isRams: boolean = false;
    password1: any;
    password2: any;
    booleanFromComponentClass: boolean = true;
    displayEnum = { login: 0, forgot: 1, notifyEmailSent: 2, createPassword: 3, twoFactorAuth: 4 };
    display = this.displayEnum.login;
    showSpinner: boolean = false;
    pwResetToken: string;
    pwResetUserId: string;
    twoFactorCardLocation: string = "";
    twoFactorCode: string = null;
    dummyUsers: any[] = [
        { fName: "Joe", lName: "Buck", username: "joe@buck.com", permission: 1 },
        { fName: "James", lName: "Orwell", username: "good@guy.org", permission: 2 },
        { fName: "Stan", lName: "Marsh", username: "south@park.co", permission: 1 },
        { fName: "Bender", lName: "Rodriguez", username: "bite@my.sma", permission: 2 },
        { fName: "Rick", lName: "Sanchez", username: "szechuan@sauce.100years", permission: 2 },
        { fName: "Bojack", lName: "Horseman", username: "horsin@around.tv", permission: 1 },
        { fName: "Andrew", lName: "Kruse", username: "the@darkness.net", permission: 1 }
    ];
    warningText: string = `
    This is a Federal computer system and is the property of the United States Government. It is for authorized use only. Users (authorized or unauthorized) have no explicit or implicit expectation of privacy.

    Any or all uses of this system and all files on this system may be intercepted, monitored, recorded, copied, audited, inspected, and disclosed to authorized site, Department of Energy, and law enforcement personnel, as well as authorized officials of other agencies, both domestic and foreign. By using this system, the user consents to such interception, monitoring, recording, copying, auditing, inspection, and disclosure at the discretion of authorized site or Department of Energy personnel.

    Unauthorized or improper use of this system may result in administrative disciplinary action and civil and criminal penalties. By continuing to use this system you indicate your awareness of and consent to these terms and conditions of use. LOG OFF IMMEDIATELY if you do not agree to the conditions stated in this warning.
    `;

    async ngOnInit()
    {
        if (this.errorMessage.indexOf("DOERER") <0 || (this.errorMessage.indexOf(this.hostName)) < 0)
        {
            let modalConfig: ModalConfig = new ModalConfig(
                "confirm",
                "**** WARNING **** WARNING **** WARNING ****",
                this.warningText,
                $("#email"),
                this.goBack,
                () => { },
                "**** WARNING **** WARNING **** WARNING ****",
                "Proceed",
                "Cancel"
            );
            setTimeout(() => this.eventService.broadcast(this.eventService._displayModal, modalConfig), 50);
        }
        this.pwResetToken = this.getParameterByName('t');
        this.pwResetUserId = this.getParameterByName('i');
        if (!this.pwResetUserId) {
            this.pwResetUserId = this.getParameterByName('r');
            if (this.pwResetUserId)
                this.isRams = true;
        }
        this.showSpinner = true;
        if (!this.pwResetToken || !this.pwResetUserId) {
            this.display = this.displayEnum.login;
        }
        else {
            this.display = this.displayEnum.createPassword;
            this.errorMessage = "Passwords require 1 uppercase, 1 lowercase, 1 number, 1 non-alphanumeric character \n\rand must be 6 characters in length or greater."
            this.errorMessageChange.emit(this.errorMessage);
        }
        this.showSpinner = false;
        this.componentEvents();
        //setTimeout(() => {this.showSpinner = false;}, 5000);
    }

    componentEvents(): void
    {
        this.listeners.push(this.eventService.on(this.eventService._focusBigButton, () =>
        {
            $(".upper-sso-button").focus();
        }))
    }

    signInWithSSO(): void
    {
        this.eventService.broadcast(this.eventService._signInWithSSO);
    }
   

    goBack(): void {
        if (window.history.length > 1)
            window.history.back();
        else {
            document.title = "";
            window.location.replace("about:blank");
        }
    }

    ngAfterViewInit(): void {
        $('input').attr('autocomplete', 'off');
    }

    requestResetPassword(): void {
        this.display = this.displayEnum.forgot;
        this.setFocusOnElements();
    };

    setFocusOnElements(): void {
        setTimeout(() => {
            var inputs = $(".center-window-rounded-login").find('input, button').filter(':visible');
            var firstInput = inputs.eq(1);
            var lastInput = inputs.last();

            /*set focus on first input*/
            firstInput.focus();

            /*redirect last tab to first input*/
            lastInput.on('keydown', function (e) {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstInput.focus();
                }
            });

            /*redirect first shift+tab to last input*/
            firstInput.on('keydown', function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastInput.focus();
                }
            });
        }, 0);
    }

    setFocusOnTwoFactor(): void {
        this.setFocusOnElements();
        setTimeout(() => {
            var inputs = $(".center-window-rounded-login").find('input').filter(':visible');
            var lastInput = inputs.last();
            lastInput.focus();
        }, 0);
    }

    getParameterByName(name: string): string {
        // if (!url) {
        var url = window.location.href;
        //}
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results)
        {
            regex = new RegExp("[#&]" + name + "(=([^&#]*)|&|#|$)");
            results = regex.exec(url)
        };
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    refreshUrl(): void {
        var num = window.location.href.lastIndexOf("?");
        if (num > 0)
            window.location.href = window.location.href.split("?")[0];
    }

    cancelPasswordReset(): void {
        this.email = "";
        this.password = "";
        this.password1 = "";
        this.password2 = "";
        this.errorMessage = "";
        this.errorMessageChange.emit(this.errorMessage);
        this.display = this.displayEnum.login;
        this.refreshUrl();
        this.setFocusOnElements();
    };

    donePasswordReset(): void {
        this.email = "";
        this.password = "";
        this.password1 = "";
        this.password2 = "";
        this.errorMessage = "";
        this.errorMessageChange.emit(this.errorMessage);
        this.display = this.displayEnum.login;
        this.refreshUrl();
        this.showSpinner = false;
        this.setFocusOnElements();
    };

    createPasswordError(result: any): void {

    }

    createPassword(): void {
        this.showSpinner = true;
        this.loadingText = "Changing password...";
        let that = this;
        let x = true;
        this.authenticationService.createPassword(this.isRams, this.pwResetUserId, this.pwResetToken, this.password1, this.password2).subscribe(result => {
            that.errorMessage = "";
            that.errorMessageChange.emit(that.errorMessage);
            if (x) {
                that.display = that.displayEnum.login;
                that.setFocusOnElements();
                that.showSpinner = false;
                //that.attemptLogin();
            } else {
                that.showSpinner = false;
                that.createPasswordError(result);
            }
        }, error => {
            that.showSpinner = false;
            that.errorMessage = "There was an error changing your password.";
            that.errorMessageChange.emit(that.errorMessage);
            that.password1 = "";
            that.password2 = "";
        });
        //this.showSpinner = true;
        //var that = this;
        //this.authenticationService.createPassword(this.pwResetUserId, this.pwResetToken, this.password1, this.password2).subscribe(result => {
        //    that.authenticationService.authenticate(result, that.password1).subscribe(authData => {
        //        if (authData.Success) {
        //            that.token = authData.AccessToken;
        //            that.login = !that.login;
        //            that.loginChange.emit(that.login);
        //            that.authenticationService.userId = authData.UserId;
        //            that.authenticationService.setTokenString(authData.AccessToken);
        //            that.fetchDataService.setRawToken(authData.AccessToken);
        //            that.clientDataService.setEmail(that.email);
        //            that.clientDataService.setName(authData.FName, authData.LName);
        //            that.password = "";
        //            that.showSpinner = false;
        //        }
        //        else if (authData.TwoFactorRequired) {
        //            that.errorMessage = "";
        //            that.display = that.displayEnum.twoFactorAuth;
        //            that.twoFactorCardLocation = "Card: " + authData.CodeLocationInfo.Card + " Column: " + authData.CodeLocationInfo.Column + " Row: " + authData.CodeLocationInfo.Row + ":  ";
        //            that.showSpinner = false;
        //        }
        //    },
        //        error => {
        //            that.email = "";
        //            that.password = "";
        //            that.password1 = "";
        //            that.password2 = "";
        //            that.showSpinner = false;
        //            that.errorMessage = error;
        //        });
        //},
        //    error => {
        //        that.email = "";
        //        that.password = "";
        //        that.password1 = "";
        //        that.password2 = "";
        //        that.errorMessage = error;
        //        that.showSpinner = false;
        //    });
    }

    resetPassword(): void {
        this.showSpinner = true;
        this.authenticationService.resetPassword(this.email).subscribe(result => {
            this.refreshUrl();
            this.display = this.displayEnum.notifyEmailSent;
            this.setFocusOnElements();
            this.errorMessage = "";
            this.errorMessageChange.emit(this.errorMessage);
            this.showSpinner = false;
        },
            error => {
                this.email = "";
                this.password = "";
                this.errorMessage = error;
                this.errorMessageChange.emit(this.errorMessage);
                this.showSpinner = false;
            });
    };

    handleTokenResponse(tokenResponse)
    {
        //if (tokenResponse && tokenResponse.Success)
        //{
        //    this.authenticationService.setAuthData(tokenResponse);
        //    this.authenticationService.setUserData(this.fetchDataService.getEmail());
        //    this.fetchDataService.fetchApps().subscribe(
        //        (apps) =>
        //        {
        //            this.fetchDataService.setApps(apps);
        //            this.fetchDataService.getUserByEmail().subscribe(data =>
        //            {
        //                if (data.fName)
        //                    this.authenticationService._firstName = data.fName;
        //                if (data.lName)
        //                    this.authenticationService._lastName = data.lName;
        //                if (data.id)
        //                    this.fetchDataService._userGuid = data.id;
        //                this.fetchDataService.setUserRoles(data.role ? data.role : [])
        //                this.login = !this.login;
        //                this.loginChange.emit(this.login);
        //                this.showSpinner = false;
        //                this.email = "";
        //                this.password = "";
        //                this.twoFactorCode = null;
        //            }, error =>
        //                {
        //                    this.showSpinner = false;
        //                    this.email = "";
        //                    this.password = "";
        //                    this.twoFactorCode = null;
        //                });
        //        }, (error) =>
        //        {
        //            this.showSpinner = false;
        //            this.email = "";
        //            this.password = "";
        //            this.twoFactorCode = null;
        //        });
        //}
        //else
        //{
        //    this.email = "";
        //    this.password = "";
        //    this.twoFactorCode = null;
        //    this.display = this.displayEnum.login;
        //    this.login = false;
        //    this.errorMessage = "Azure SSO Failed.";
        //}
    }

    attemptLogin() {
        this.showSpinner = true;
        this.loadingText = "Logging in...";
        var that = this;
        let userObj: any = {
            email: this.email,
            password: this.password
        }
        if (this.display == this.displayEnum.twoFactorAuth)
            userObj.twoFactorCode = this.twoFactorCode;



        //Comment all below this to bypass login
        this.authenticationService.authenticate(new User(userObj)).subscribe(
            (data) => {
                if (data && data.Success) {
                    that.errorMessage = "";
                    that.errorMessageChange.emit(that.errorMessage);
                    that.authenticationService.setAuthData(data);
                    that.authenticationService.setUserData(userObj.email);
                    //if (that.fetchDataService.getPermissions() <= that.fetchDataService.admin) {
                    //    that.loadingText = "Fetching Users...";
                    //    that.fetchDataService.fetchUsers().subscribe(
                    //        (users) => {
                    //            this.fetchDataService.saveUsers(users);
                    //            that.showSpinner = false;
                    //            that.email = "";
                    //            that.password = "";
                    //            that.login = !that.login;
                    //            that.loginChange.emit(that.login);
                    //        }, (error) => {
                    //            let blah = error; that.twoFactorCode = null;
                    //            that.email = "";
                    //            that.password = "";
                    //            that.password1 = "";
                    //            that.password2 = "";
                    //            that.errorMessage = "User Fetch Failed";
                    //            setTimeout(() => {
                    //                that.login = !that.login;
                    //                that.loginChange.emit(that.login);
                    //            }, 5000);
                    //            that.showSpinner = false;
                    //        }
                    //    );
                    //} else {
                    that.email = "";
                    that.password = "";
                    that.twoFactorCode = null;
                    that.fetchDataService.fetchApps().subscribe(
                        (apps) => {
                            that.fetchDataService.setApps(apps);
                            that.fetchDataService.getUserByEmail().subscribe(data => {
                                if (data.fName)
                                    that.authenticationService._firstName = data.fName;
                                if (data.lName)
                                    that.authenticationService._lastName = data.lName;
                                if (data.id)
                                    that.fetchDataService._userGuid = data.id;
                                that.fetchDataService.setUserRoles(data.role ? data.role : [])
                                that.login = !that.login;
                                that.loginChange.emit(that.login);
                                that.showSpinner = false;
                                that.email = "";
                                that.password = "";
                                that.twoFactorCode = null;
                            }, error => {
                                that.showSpinner = false;
                                that.email = "";
                                that.password = "";
                                that.twoFactorCode = null;
                            });
                        }, (error) => {
                            that.showSpinner = false;
                            that.email = "";
                            that.password = "";
                            that.twoFactorCode = null;
                        }
                    )
                    //}
                } else if (data.TwoFactorRequired) {
                    that.errorMessage = "";
                    that.errorMessageChange.emit(that.errorMessage);
                    that.display = that.displayEnum.twoFactorAuth;
                    that.setFocusOnTwoFactor();
                    that.twoFactorCardLocation = "Card: " + data.CodeLocationInfo.Card + " Row: " + data.CodeLocationInfo.Row + " Column: " + data.CodeLocationInfo.Column;
                    that.showSpinner = false;
                } else {
                    that.errorMessage = data.Error;
                    that.errorMessageChange.emit(that.errorMessage);
                    that.showSpinner = false;
                    that.email = "";
                    that.password = "";
                    that.twoFactorCode = null;
                    that.display = that.displayEnum.login;
                    setTimeout(() => $("#email").focus(), 0);
                }
            }, (error) => {
                that.display = that.displayEnum.login;
                that.twoFactorCode = null;
                that.email = "";
                that.password = "";
                that.password1 = "";
                that.password2 = "";
                that.errorMessage = error;
                that.errorMessageChange.emit(that.errorMessage);
                that.showSpinner = false;
                setTimeout(() => $("#email").focus(), 0);

            }
        );

        ////Uncomment these lines to bypass login
        //this.fetchDataService.setAuthData(null, new JwtHelper().decodeToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJSYW1zQWRtaW4iOiJ0cnVlIiwic3ViIjoia3J1c2VhdyIsImp0aSI6IjQ4MzljODE1LTZhZWItNDk2Yy1iMTRhLWQ3NjA3MzEyZmY3YSIsImlhdCI6MTUyNzcwNTUwOSwiRW1haWwiOiJLcnVzZUFXQG52LmRvZS5nb3YiLCJuYW1laWQiOiJrcnVzZWF3IiwibmJmIjoxNTI3NzA1NTA5LCJleHAiOjE1Mjc3OTE5MDksImlzcyI6ImRvZXJlci51cyIsImF1ZCI6IkFkZCBhY2Nlc3MifQ.x3QbwTVgjJrM6sCZ0QZrJt_lKe3G7eoCgQYF-2lTh2s"), null, {
        //    FName: "Andrew",
        //    LName: "Kruse",
        //    Email: "the@darkness.net",
        //    permission: 1,

        //});
        //this.fetchDataService.saveUsers(this.dummyUsers);
        //that.fetchDataService.fetchApps().subscribe(
        //    (apps) => {
        //        that.fetchDataService.setApps(apps);
        //        that.login = !that.login;
        //        that.loginChange.emit(that.login);
        //        that.showSpinner = false;
        //        that.email = "";
        //        that.password = "";
        //        that.twoFactorCode = null;

        //    }, (error) => {
        //        that.showSpinner = false;
        //        that.email = "";
        //        that.password = "";
        //        that.twoFactorCode = null;
        //    }
        //);

        ////this.authenticationService.authenticateCheckRequirePwReset(this.email, this.password).subscribe(result => {
        ////    if (result == false) {
        //that.authenticationService.authenticate(that.email, that.password, that.twoFactorCode).subscribe(authData => {
        //    if (authData.Success) {
        //        that.token = authData.AccessToken;
        //        that.login = !that.login;
        //        that.loginChange.emit(that.login);
        //        that.authenticationService.userId = authData.UserId;
        //        that.authenticationService.setTokenString(authData.AccessToken);
        //        that.fetchDataService.setRawToken(authData.AccessToken);
        //        that.clientDataService.setEmail(that.email);
        //        that.clientDataService.setName(authData.FName, authData.LName);
        //        that.password = "";
        //        that.showSpinner = false;
        //    }
        //    else if (authData.TwoFactorRequired) {
        //        that.errorMessage = "";
        //        that.display = that.displayEnum.twoFactorAuth;
        //        that.twoFactorCardLocation = "Card: " + authData.CodeLocationInfo.Card + " Column: " + authData.CodeLocationInfo.Column + " Row: " + authData.CodeLocationInfo.Row + ":  ";
        //        that.showSpinner = false;
        //    }

        //    //this.eventService.broadcast("authToken", token);
        //},
        //    error => {
        //        that.display = that.displayEnum.login;
        //        that.twoFactorCode = null;
        //        that.email = "";
        //        that.password = "";
        //        that.password1 = "";
        //        that.password2 = "";
        //        that.errorMessage = error;
        //        that.showSpinner = false;
        //    });
        //}
        //else {
        //    this.display = this.displayEnum.createPassword;
        //    this.showSpinner = false;
        //}

        //},
        //    error => {
        //        that.email = "";
        //        that.password = "";
        //        that.password1 = "";
        //        that.password2 = "";
        //        that.errorMessage = error;
        //        that.showSpinner = false;
        //    });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/login.component.ts